import type { ProjectViewBidsSearchMetadata } from './project-view-bids-search-metadata.model';

export interface GenerateProjectViewBidsSearchMetadataOptions {
  readonly projectId: number;
  readonly vectorQuery?: string;
  readonly searchFilters?: {
    readonly minAmount?: number;
    readonly maxAmount?: number;
    readonly maxPeriod?: number;
    readonly minBidderOverallRating?: number;
    readonly bidderCountryCodes?: readonly string[];
    readonly minBidderReviewCount?: number;
    readonly minBidderJobCompletionRate?: number;
    readonly isBidderFreelancerVerified?: boolean;
    readonly isBidderPreferredFreelancer?: boolean;
    readonly isVideoBid?: boolean;
    readonly isBidderOnline?: boolean;
    readonly positiveQueries?: readonly string[];
    readonly negativeQueries?: readonly string[];
    readonly bidderName?: string;
  };
  readonly timestamp?: number;
}

export function generateProjectViewBidsSearchMetadata({
  projectId,
  vectorQuery,
  searchFilters,
  timestamp,
}: GenerateProjectViewBidsSearchMetadataOptions): ProjectViewBidsSearchMetadata {
  return {
    id: projectId,
    projectId,
    vectorQuery: vectorQuery ?? '',
    searchFilters: searchFilters ?? {},
    timestamp: timestamp ?? Date.now(),
  };
}
